import React from "react";
import { withFormik } from "formik";

import { Modal } from "../../../../components/modal";
import { ValidatedForm } from "../../../../components";
import { type PackRequest } from "../types/state";
import validationSchemas from "../../../../utils/validationSchemas";
import { type EnableTrialModalProps, type EnableTrialModalWithFormProps } from "./types";
import { RequestOrEnableTrialForm } from "./RequestOrEnableTrialForm";
import RequestPackModalActions from "./RequestPackModalActions";
import ModalSizes from "../../../../enums/modalSizes";

import "./packRequestModal.scss";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";

export const EnablePackTrialModal: React.FC<EnableTrialModalWithFormProps> = (props) => {
  const { values, isValid, resetForm, onCancelPackRequest, onTrialEnable } = props;
  const isPaidPacksEnabled = !!useFeatureFlag(FeatureFlags.PaidPacks);

  const renderModalActions = (closeModal: any) => {
    return (
      <RequestPackModalActions
        onSubmit={() => {
          onTrialEnable(values);
          closeModal();
        }}
        onCancel={() => {
          closePackRequestModal();
          closeModal();
        }}
        isValid={isValid}
        submitText={isPaidPacksEnabled ? "Start Trial" : "Purchase Now"}
      />
    );
  };

  const closePackRequestModal = () => {
    resetForm();
    onCancelPackRequest();
  };

  return (
    <Modal
      className={"pack-request-modal"}
      title={isPaidPacksEnabled ? "Start Free Trial" : "Start Pack Trial"}
      open={props.isOpen}
      renderModalActions={renderModalActions}
      onCancel={closePackRequestModal}
      size={ModalSizes.tiny}
      dataTestId="enable-pack-trial-modal"
    >
      <ValidatedForm formWidthComputer={16} formWidthTablet={16} {...props}>
        <RequestOrEnableTrialForm {...props} canRenew={!isPaidPacksEnabled} />
      </ValidatedForm>
    </Modal>
  );
};

/* istanbul ignore next */
const ConnectedComponent = withFormik<EnableTrialModalProps, PackRequest>({
  validationSchema: validationSchemas.packTrialRequestValidationSchema,
  isInitialValid: false,
  mapPropsToValues: (props: EnableTrialModalProps) => {
    return {
      packId: props.packId,
    } as PackRequest;
  },
  handleSubmit: () => {}, // NOSONAR
  enableReinitialize: true,
})(EnablePackTrialModal);

export default ConnectedComponent;
